export const isZipcode6 = (string: string): boolean => /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test(string);
export const isZipcode4 = (string: string): boolean => /^[1-9][0-9]{3}$/i.test(string);
export const isZipcode = (string: string): boolean => isZipcode4(string) || isZipcode6(string);
